import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const DollarSignCircleIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 17 17",
    },
    <path
      fill="currentColor"
      fillOpacity={0.67}
      fillRule="evenodd"
      d="M16.66 8.673a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14M5.16 7.17c0-1.11.9-2.009 2.009-2.009h1.665l.27-1.488.984.178-.237 1.31h1.973v1H9.67l-.365 2.017h.938a2.008 2.008 0 1 1 0 4.017H8.576l-.27 1.489-.984-.178.237-1.311H5.586v-1H7.74l.365-2.017H7.17c-1.11 0-2.009-.9-2.009-2.008m3.128 1.008.365-2.017H7.17a1.008 1.008 0 1 0 0 2.017zm.835 1-.366 2.017h1.485a1.008 1.008 0 0 0 0-2.017z"
      clipRule="evenodd"
    />
  );
